import React from 'react';
import Modal from 'react-responsive-modal';


class SelectTerminalsModal extends React.Component {

	plain = null;

	constructor(props) {
		super(props);
		this.plain = props.plain;
		this.state = {listTerminalInfo: [], dirtyCounter: 0};
	}
	init = (listTerminal) => {
		let listTerminalInfo = [];
		for( let t of listTerminal ) {
			listTerminalInfo.push({checked: false, terminal: t});
		}
		this.setState({listTerminalInfo: listTerminalInfo})
	}

	onTerminalChecked = (e, index) => {
		this.state.listTerminalInfo[index].checked = e.target.checked;
		this.setState({dirtyCounter: this.state.dirtyCounter + 1})
	}
	
	selectTerminals = () => {
		let listTerminal = [];
		for( let t of this.state.listTerminalInfo) {
			if( t.checked )
				listTerminal.push( t.terminal );
		}
		this.plain.selectTerminals( listTerminal );
		this.plain.closeSelectTerminalsModal();
	}
	
	render() {
		
		let tableRowsHtml = this.state.listTerminalInfo.map( (terminalInfo,index) => {
			return (
				<tr key={index}>
					<td><input type='checkbox' onChange={(e)=> {this.onTerminalChecked(e, index)} } 
						checked={this.state.listTerminalInfo[index].checked}/>
					</td>
					<td>{terminalInfo.terminal.bankCode}</td>
					<td>{terminalInfo.terminal.tid}</td>
					<td>{terminalInfo.terminal.comments}</td>	{/* comments */}
				</tr>
			);
		});
		return (
			<Modal 
				open={this.plain.state.isSelectTerminalsModalOpen} onClose={this.plain.closeSelectTerminalsModal} center 
				styles={styleModal} closeOnOverlayClick={false} animationDuration={1} 
			>
				<div>
					<div style={localStyles.divHeader}>
						Вибрати термінали
					</div>
					<div style={{height: '300px', overflowY: 'auto', overflowX: 'hidden', margin: '20px' }}>
						<table border='1'>
						<thead style={{fontWeight: 'bold'}}>
							<tr>
								<td>&nbsp;</td><td>Еквайр</td><td>Термінал</td><td>Примітки</td>							
							</tr>
						</thead>
						<tbody>
							{tableRowsHtml}
						</tbody>
						</table>
					</div>
					<div style={{margin: '20px', textAlign: 'right'}}>
						<button type='button' style={{padding: '5px 20px 5px 20px'}} 
							onClick={this.selectTerminals}
						>Ok</button>
					</div>
				</div>
			</Modal>
			
		)
	}
}

const styleModal = {
	modal: {
		background: '#ffffff',
		padding: '0px',
		borderRadius: '21px',
		maxWidth: '1200px',
		width: '100%',
	},
	closeButton: {
		top: '10px',
		right: '10px',
		fill: '#FF0000',
		outline: 'none',
	},
};

const localStyles = {
	divHeader: {
		fontSize: '16pt',
		textAlign: 'center',
		padding: '10px',
		borderRadius: '21px 21px 0 0',
		backgroundColor: '#F0F0F0'
	},
	divParameters: {
		marginTop: '10px',
		padding: '10px'
	},
	divWaiting: {
		textAlign: 'center',
		padding: '7px'
	},
	divButtons: {
		marginTop: '7px',
		padding: '10px',
		marginRight: '15px',
		textAlign: 'right'
	}
};

export default SelectTerminalsModal;
